import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import Loading from '../Loading';
import { I18nContext } from 'utils/I18n/context';

const DataComponentTablePromo = ({
    loading,
    data
}) => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.dataTable || {};

    const getKey = useCallback((data) => {
        if (React.isValidElement(data)) {
            return getKey(data.props.children);
        }

        return data;
    }, []);

    return (
        <div className="loading-wrapper">
            {loading && data.length
                ? <div className="loading-wrapper__item"><Loading/></div>
                : null
            }
            {!loading && data.length === 0
                ? <div className="empty-data-message">
                    <p>{staticNames.noData || 'No data available'}</p>
                </div>
                : null
            }
            {data.map((item, i) => {
                const { className, ...rest } = item || {};

                return (
                    <div className="promo-wrap" key={i}>
                        <div className="wrap__desktop">
                            <div className="promo-header">
                                <span className="promo-header__num">#{rest.id} </span>
                                <span>{rest.selfLink}</span>
                            </div>
                            <div className="promo-image">{rest.image}</div>
                            <div className="promo-title"><span>{rest.title}</span></div>
                            <div className="promo-link"><span>{rest.url}</span></div>
                            <div className="promo-actions">
                                {rest.action}
                            </div>
                        </div>
                        <div className="wrap__mobile">
                            <div className="promo-content">
                                <div className="promo-image">{rest.image}</div>
                                <div className="promo-info-container">
                                    <div className="promo-header">
                                        <span className="promo-header__num">#{rest.id} </span>
                                        <span>{rest.selfLink}</span>
                                    </div>
                                    <div className="promo-title"><span>{rest.title}</span></div>
                                    <div className="promo-link"><span>{rest.url}</span></div>
                                </div>
                            </div>
                            <div className="promo-actions">
                                {rest.action}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    );
};

DataComponentTablePromo.propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.array
};

DataComponentTablePromo.defaultProps = {
    loading: false,
    data: []
};

export default DataComponentTablePromo;
